<!--
  The stage a section's illustration stands on: the dot field fading out from
  the middle, with no edge of its own on the page, and a soft light behind
  where one is asked for.
-->
<template>
  <div class="relative flex h-full flex-col justify-center lg:min-h-[420px]">
    <div class="pointer-events-none absolute inset-0 [mask-image:radial-gradient(ellipse_60%_60%_at_50%_50%,#000_40%,transparent)]" aria-hidden="true">
      <div class="cell-dots absolute inset-0"></div>
    </div>
    <!-- A light, only where a stage asks for one (glow), coming up last and
         slowly once what stands on the stage has faded in. Off by default. -->
    <div v-if="glow" class="pointer-events-none absolute left-1/2 top-1/2 h-72 w-72 -translate-x-1/2 -translate-y-1/2 rounded-full blur-3xl" :class="glow" data-aos="fade" data-aos-delay="700" data-aos-duration="1500" aria-hidden="true"></div>
    <slot />
  </div>
</template>

<script setup lang="ts">
defineProps<{ glow?: string }>()
</script>
